module.exports = __webpack_public_path__ + "static/media/Skills_1.07370a60.png";